export default "__VITE_ASSET__e5accfd0__"